export default "__VITE_PUBLIC_ASSET__8cb89d1a__"